import { Routes, Route } from "react-router-dom";
// import ClientLayout from "../layouts/ClientLayout";
import TaskBoardWrapper from "../pages/technique/TaskBoardWrapper";
import TechniqueLayout from "../layouts/TechniqueLayout";
import TicketDetailCard from "../pages/technique/PageDetail";
import TableauBord from "../pages/technique/tableau_bord";
// import TaskDetailPage from "../pages/technique/TaskDetailPage";
// import TicketForm from "../pages/technique/AddTaskForm";

const TechniqueRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<TechniqueLayout />}>
                <Route path="home" element={<TaskBoardWrapper />} />
                   <Route
                       path="/task/:id"
                       element={<TicketDetailCard />}
                   />
                    <Route
                       path="/dashboard"
                       element={<TableauBord />}
                   />

                {/* <Route path="/task/:taskId" element={< TaskDetailPage/>} />
                <Route path="task/create" element={<TicketForm />} /> */}
            </Route>
        </Routes>
    );
};

export default TechniqueRoutes;
